<template>
  <RfSegmentsTableView />
</template>

<script setup>
import RfSegmentsTableView from "./RfSegmentsTableView.vue";
</script>
